import { Compass } from '@orgus/ui/icons';
import { useNavigate } from 'react-router';
import { PageBody } from '../components/shell/PageBody.tsx';
import { Button } from '@orgus/ui';
import { EmptyState } from '@orgus/ui';

export default function NotFound() {
  const navigate = useNavigate();
  return (
    <PageBody>
      <EmptyState
        size="page"
        icon={<Compass />}
        title="There is no page at this address"
        description="The link may be old. Ctrl K reaches every page."
        action={
          <Button variant="primary" onClick={() => navigate('/')}>
            Go to Overview
          </Button>
        }
      />
    </PageBody>
  );
}
